// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Prompt_wrapper__2glYb","text":"Prompt_text__30pnA","infoIcon":"Prompt_infoIcon__2iQ97"};